(() => {
  'use strict';

  const roots = new Map();

  function initialize(scope) {
    scope.querySelectorAll('[data-hardware-r2]').forEach(root => {
      if (roots.has(root)) return;

      const image = root.querySelector('[data-hw-image]');
      const caption = root.querySelector('[data-hw-caption]');
      const status = root.querySelector('[data-hw-status]');
      const colorLabel = root.querySelector('[data-hw-selected-color]');
      const productThumb = root.querySelector('[data-hw-product-thumb]');
      const swatches = [...root.querySelectorAll('[data-hw-color]')];
      const views = [...root.querySelectorAll('[data-hw-view]')];
      const viewRail = root.querySelector('.hw-view-rail');
      if (!image || !caption || !colorLabel || !productThumb || !swatches.length || !views.length || !viewRail) return;

      const controller = new AbortController();
      const { signal } = controller;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let selectedColor = swatches.find(button => button.getAttribute('aria-pressed') === 'true') || swatches[0];
      let currentView = 0;
      let timer = null;
      let previewHeld = false;

      const viewData = index => index === 0 ? selectedColor.dataset : views[index].dataset;

      const showView = (index, announce = false) => {
        currentView = (index + views.length) % views.length;
        const view = viewData(currentView);
        const nextSource = new URL(view.src, document.baseURI).href;
        image.dataset.loading = String(image.src !== nextSource);
        image.src = view.src;
        image.alt = view.alt;
        image.width = Number(view.width);
        image.height = Number(view.height);
        caption.textContent = view.caption;
        views.forEach((button, buttonIndex) => {
          const active = buttonIndex === currentView;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        if (announce && status) status.textContent = view.caption;
      };

      const stopRotation = () => {
        window.clearInterval(timer);
        timer = null;
        root.classList.remove('is-autoplaying');
      };

      const startRotation = () => {
        if (reduceMotion || previewHeld) return;
        window.clearInterval(timer);
        timer = window.setInterval(() => showView(currentView + 1), 2800);
        root.classList.add('is-autoplaying');
      };

      const holdPreview = index => {
        previewHeld = true;
        stopRotation();
        showView(index, true);
      };

      const releasePreview = () => {
        previewHeld = false;
        startRotation();
      };

      const selectColor = button => {
        selectedColor = button;
        colorLabel.textContent = button.dataset.hwColor === 'gray' ? 'Gray' : 'Silver';
        swatches.forEach(swatch => swatch.setAttribute('aria-pressed', String(swatch === button)));
        productThumb.src = button.dataset.src;
        showView(0, true);
        startRotation();
      };

      image.addEventListener('load', () => { image.dataset.loading = 'false'; }, { signal });
      swatches.forEach(button => button.addEventListener('click', () => selectColor(button), { signal }));
      views.forEach((button, index) => {
        button.addEventListener('mouseenter', () => holdPreview(index), { signal });
        button.addEventListener('focus', () => holdPreview(index), { signal });
        button.addEventListener('click', () => {
          previewHeld = false;
          stopRotation();
          showView(index, true);
          startRotation();
        }, { signal });
      });
      viewRail.addEventListener('mouseleave', releasePreview, { signal });
      viewRail.addEventListener('focusout', event => {
        if (!viewRail.contains(event.relatedTarget)) releasePreview();
      }, { signal });
      swatches.forEach(button => { button.disabled = false; });
      if (!reduceMotion) startRotation();

      roots.set(root, {
        destroy() {
          window.clearInterval(timer);
          controller.abort();
        }
      });
    });
  }

  function destroy(scope) {
    scope.querySelectorAll('[data-hardware-r2]').forEach(root => {
      roots.get(root)?.destroy();
      roots.delete(root);
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
})();
